export enum VisucloudRoleScope {
    Global,
    Regional
}
